import { render } from "./answerDetailLine.vue?vue&type=template&id=1390907a&scoped=true"
import script from "./answerDetailLine.vue?vue&type=script&lang=js"
export * from "./answerDetailLine.vue?vue&type=script&lang=js"

import "./answerDetailLine.vue?vue&type=style&index=0&id=1390907a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1390907a"]])

export default __exports__